import React from "react";
import PropTypes from "prop-types";
import styles from "./LoadingScreenLayout.scss";
import { Column } from "../layout/Column";
import { AppLogo } from "../misc/AppLogo";
import configs from "../../utils/configs";
import configManager from "../../singleton/ConfigManager";
import { getThemeColor } from "../../utils/theme";
import classNames from "classnames";

export function LoadingScreenLayout({ center, bottom, showLogo = true }) {
  const primaryColor = getThemeColor("primary-color");

  return (
    <div
      className={styles.loadingScreenLayout}
      style={configManager.config.loadingScreen.useSceneBackground ? { backgroundColor: `${primaryColor}` } : {}}
    >
      <div className={classNames(styles.center, styles.container)}>
        {!["eventfy", "next reality digital", "mud foundation"].includes(configs.APP_NAME.toLowerCase()) &&
          showLogo && <AppLogo className={styles.logo} />}
        {center}
      </div>
      {bottom && (
        <Column center className={styles.bottom}>
          {bottom}
        </Column>
      )}
    </div>
  );
}

LoadingScreenLayout.propTypes = {
  center: PropTypes.node,
  bottom: PropTypes.node,
  showLogo: PropTypes.bool
};
